import React from 'react';
import { Layout, Select } from 'antd';

import '../styles/Footer.css';
const { Option } = Select;

const handleChangeFamilySite = value => {
  if(value === "stickerfarm"){
    window.open('http://stickerfarm.mojitok.com', '_blank');
  }else if(value === "mojitok_ios"){
    window.open('https://itunes.apple.com/us/app/mojitok-stickers/id1401180608?l=ko&ls=1&mt=8', '_blank');
  }else{
    console.log(value);
  }

}

const Footer = props => (
  <Layout.Footer className="footer-wrapper">
    <div className="footer">
      <div className="footer-logo-familySite">
        <img src={require('../img/logo.svg')} className="footer-mojitok-logo" alt="mojitok-logo"/>
      </div>
      <div className="footer-info-wrapper">
        <div className="footer-info-box">
          <p className="left">Address</p>
          <p className="right">5F 509 Office, Seoul Startup Hub 21, Baekbeom-ro 31-gil, Mapo-gu, Seoul, Republic of Korea (04147)</p>
        </div>
        <div className="footer-info-box">
          <p className="left">Email</p>
          <p className="right">business@mojitok.com</p>
        </div>
      </div>
      <div className="footer-copyright">
        <strong style={{marginRight:8}}>Copyright</strong> © {new Date().getFullYear()} Platfarm Inc. All rights reserved.
      </div>
    </div>
  </Layout.Footer>
);
export default Footer;
